import React, { createContext, useState } from 'react';
import { fetchAllServices } from './bikeService.service';
export const BikeServiceProvider = createContext();


export const BikeServiceContext = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [services, setServices] = useState([]);
    const [error, setError] = useState(null);
    const clearUserSession = () => {
        localStorage.removeItem('userId');
        localStorage.removeItem('sessionToken');
    };

    const loadServices = async () => {
        setIsLoading(true);
        try {
            const response = await fetchAllServices();
            setIsLoading(false);
            const { data } = response;
            if (data.status.toLowerCase() === 'ok') {
                setError(null);
                setServices(data.data);
            } else {
                setError('Something went wrong');
            }
        } catch (error) {
            setTimeout(() => { window.location.href = '/auth/login'; }, 5000);
            setIsLoading(false);
            clearUserSession();
            setError('Session abgelaufen, bitte neu anmelden');
        }
    }

    return (
        <BikeServiceProvider.Provider value={{
            isLoading,
            services,
            error,
            loadServices
        }}>
            {children}
        </BikeServiceProvider.Provider>

    )
}